import {
  HHBaseTable,
  HHCard,
  HHIconButtonMenu,
} from '@hinge-health/react-component-library';
import { capitalizeFirstLetterAndSpaceSnakeString } from '../../utils/bills-utils';
import { ClientInsurerIndexRow } from './client-insurer-index-utils';

interface SelectedContractsGridProps {
  rows: ClientInsurerIndexRow[];
  onDeleteRow: (ciId: number) => void;
}

export const SelectedContractsGrid = ({
  rows,
  onDeleteRow,
}: SelectedContractsGridProps): JSX.Element => (
  <HHCard sx={{ width: '100%' }}>
    <HHBaseTable
      headerRowBottomBorder="1px solid rgba(0,0,0,0.12)"
      bodyRowBorder={{ borderBottom: '1px solid rgba(0,0,0,0.12)' }}
      bodyTypographyVariant="body2"
      tableHeaders={[
        { value: 'CI ID', align: 'left' },
        { value: 'Client', align: 'left' },
        { value: 'Insurer', align: 'left' },
        { value: 'Partnership', align: 'left' },
        { value: 'Contract Type', align: 'left' },
        { value: 'Contract Dates', align: 'left' },
        { value: 'Billing Type', align: 'left' },
        { value: '', align: 'left' },
      ]}
      bodyContent={rows.map(row => ({
        ciId: { value: row.id },
        client: { value: row.clientName },
        insurer: { value: row.insurerName },
        partnership: { value: row.contractPartnershipName ?? '--' },
        contractType: { value: row.contractType ?? '--' },
        contractDates: { value: row.contractDateRange ?? '--' },
        billingType: {
          value: row.billingType
            ? capitalizeFirstLetterAndSpaceSnakeString(row.billingType)
            : '--',
        },
        actions: {
          value:
            rows.length <= 1 ? (
              ''
            ) : (
              <HHIconButtonMenu
                aria-label="Grid action row menu"
                role="menuitem"
                menuItems={[
                  {
                    label: 'Remove from list',
                    onClick: () => onDeleteRow(row.id),
                  },
                ]}
              />
            ),
        },
      }))}
    />
  </HHCard>
);
